import { observer } from 'mobx-react-lite'
import { type Integration } from 'entities/Integrations'
import { ReconnectButton } from 'widgets/ContactsDetails/ui/ContactsIntegrations/ui/ReconnectButton/ReconnectButton'

export const NangoIntegration = observer(({ integration }: { integration: Integration }) => {
  if (!integration?.isConnected) return <ReconnectButton redirectKey={integration.key} />
  return null
})
